"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationsContract = void 0;
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../../schemas");
const applications_request_1 = require("./applications.request");
const applications_response_1 = require("./applications.response");
const c = (0, core_1.initContract)();
exports.ApplicationsContract = c.router({
    search: {
        method: 'GET',
        path: '/',
        query: applications_request_1.ApplicationSearchQuerySchema,
        responses: {
            200: applications_response_1.ApplicationSearchListResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
}, { pathPrefix: '/applications' });
